'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListType;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

require('../styles/ListType.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListType(_ref) {
  var type = _ref.type;

  return _react2.default.createElement(
    'div',
    { className: 'cp-list-type', 'data-test-id': 'list-type' },
    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_purpose_' + type })
  );
}

ListType.propTypes = {
  type: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type/components/ListType.component.js
// module id = 1318
// module chunks = 0